import isEqual from "lodash.isequal";
import React from "react";
import ReactGridLayout, { Responsive, WidthProvider } from "react-grid-layout";
import { compact, compactType } from "./react-grid-layout-utils";

function getIndentationValue(param, breakpoint) {
  // $FlowIgnore TODO fix this typedef
  if (param == null) return null;
  // $FlowIgnore TODO fix this typedef
  return Array.isArray(param) ? param : param[breakpoint];
}

class FixedReactGridLayout extends ReactGridLayout {
  onLayoutMaybeChanged(newLayout, oldLayout) {
    super.onLayoutMaybeChanged(newLayout, oldLayout);
    const { cols } = this.props;

    if (!isEqual(oldLayout, newLayout)) {
      newLayout = compact(newLayout, compactType(this.props), cols);

      super.setState({
        layout: newLayout,
        activeDrag: null,
      });

      this.forceUpdate();
    }
  }
}

class FixedResponsive extends Responsive {
  onLayoutChange = (layout) => {
    this.props.onLayoutChange(layout, {
      ...this.props.layouts,
      [this.state.breakpoint]: layout,
    });
  };

  render() {
    /* eslint-disable no-unused-vars */
    const {
      breakpoint,
      breakpoints,
      cols,
      layouts,
      margin,
      containerPadding,
      onBreakpointChange,
      onLayoutChange,
      onWidthChange,
      ...other
    } = this.props;
    /* eslint-enable no-unused-vars */

    return (
      <FixedReactGridLayout
        {...other}
        // $FlowIgnore should allow nullable here due to DefaultProps
        margin={getIndentationValue(margin, this.state.breakpoint)}
        containerPadding={getIndentationValue(
          containerPadding,
          this.state.breakpoint
        )}
        onLayoutChange={this.onLayoutChange}
        layout={this.state.layout}
        cols={this.state.cols}
      />
    );
  }
}

const ResponsiveGridLayout = WidthProvider(FixedResponsive);

const DraggableResizableGrid = (props) => {
  const layout = [];
  const layouts = {
    lg: layout,
    md: layout,
    sm: layout,
    xs: layout,
    xxs: layout,
  };

  return (
    <ResponsiveGridLayout
      className="layout"
      layouts={layouts}
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
      draggableHandle=".gridDragHandle"
      compactType="horizontal"
    >
      {props.children}
    </ResponsiveGridLayout>
  );
};

export default DraggableResizableGrid;
